import { getMessagesData, deleteMessageData } from '../libs/apis/MessageApi';

export const GET_MESSAGES_REQUEST = 'GET_MESSAGES_REQUEST';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAILURE = 'GET_MESSAGES_FAILURE';

export const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST';
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';

export const getMessages = params => dispatch => {
  dispatch({ type: GET_MESSAGES_REQUEST });
  return getMessagesData(params)
    .then(response =>
      dispatch({
        type: GET_MESSAGES_SUCCESS,
        payload: response.data.shops
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MESSAGES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGochiMenu = messageId => dispatch => {
  dispatch({ type: DELETE_MESSAGE_REQUEST });
  return deleteMessageData(messageId)
    .then(response =>
      dispatch({
        type: DELETE_MESSAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_MESSAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
